import React from 'react'
import Banner from './../Shared/Banner/Banner';
import MDMessage from './Message/Message';

export default function About() {
  return (
    <div>
        <Banner title="About Section" />
        <MDMessage />
    </div>
  )
}
